import { CurrentShareholderGeneralMeetingModel } from './current-shareholder-general-meeting.model';
import { GeneralMeetingModel } from './general-meeting.model';

export class VotingInstructionsModel {
    generalMeeting: GeneralMeetingModel;
    shareholderData: CurrentShareholderGeneralMeetingModel;
    isEditing = false;

    constructor(init: VotingInstructionsModel) {
        Object.assign(this, init);
    }
}
